<div class="dialog-container">
  <div mat-dialog-title class="mat-dialog-title">
    <mat-icon *ngIf="showIcon" [ngStyle]="{ color: iconColor }">
      {{ iconType }}
    </mat-icon>
    <span class="mat-dialog-title-style">IMPORTANTE</span>
  </div>

  <mat-dialog-content>
    <ng-container>
      <!-- Título dinámico extraído del HTML -->
      <div style="text-align: center; margin-bottom: 16px">
        <ng-container *ngFor="let t of titulos">
          <h1 *ngIf="t.tag === 'h1'" style="margin: 4px 0">{{ t.text }}</h1>
          <h2 *ngIf="t.tag === 'h2'" style="margin: 4px 0">{{ t.text }}</h2>
          <p *ngIf="t.tag === 'p'" style="margin: 4px 0">{{ t.text }}</p>
        </ng-container>
      </div>

      <!-- Lista de estados -->
      <ul style="list-style: none; padding-left: 30px; text-align: left">
        <li *ngFor="let estado of estadoKeys">
          {{ estado.toUpperCase() }} - {{ data.conteo[estado] || 0 }}
        </li>
      </ul>
    </ng-container>
  </mat-dialog-content>

  <div mat-dialog-actions class="mat-dialog-actions row">
    <button class="button-confirm-style" (click)="dialogRef.close()">Ok</button>
  </div>
</div>